import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader } from "@/components/common";
import { PermGrid } from "@/pages/Employees";

export default function Roles() {
  const { can } = useApp();
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/roles").then((r) => setRoles(r.data));
    api.get("/users").then((r) => setUsers(r.data)).catch(() => {});
  }, []);
  const save = async (role) => {
    try {
      await api.put(`/roles/${role.key}`, { permissions: role.permissions });
      toast.success(`${role.name} defaults saved`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const sups = users.filter((u) => u.role === "supervisor");
  return (
    <div>
      <PageHeader title="Supervisors & Roles" subtitle="Role defaults apply to every user with that role; individual overrides are set on the Employees page." />
      <section className="mb-8">
        <h2 className="mb-3 text-base font-semibold md:text-lg">Supervisor teams</h2>
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3" data-testid="supervisor-teams">
          {sups.map((s) => (
            <div key={s.id} className="panel p-4">
              <div className="font-semibold text-[#283F91] dark:text-blue-300">{s.name}</div>
              <ul className="mt-2 space-y-1 text-sm">
                {users.filter((u) => u.supervisor_id === s.id).map((u) => <li key={u.id} className="flex justify-between"><span>{u.name}</span><span className="text-[var(--muted-ink)]">{u.patient_count} patients</span></li>)}
              </ul>
            </div>
          ))}
          {!sups.length && <p className="text-sm text-[var(--muted-ink)]">No supervisors yet.</p>}
        </div>
      </section>
      {roles.map((role, i) => (
        <section key={role.key} className="panel mb-4 p-5" data-testid={`role-${role.key}`}>
          <div className="mb-3 flex items-center justify-between">
            <h2 className="text-base font-semibold">{role.name}</h2>
            {role.key !== "admin" && can("action:manage_users") && <button className="btn btn-primary btn-sm" onClick={() => save(role)} data-testid={`save-role-${role.key}`}>Save defaults</button>}
          </div>
          {role.key === "admin" ? <p className="text-sm text-[var(--muted-ink)]">Administrators always have full access to every page and action.</p> : (
            <PermGrid testid={`role-grid-${role.key}`} perms={role.permissions} onToggle={(k, v) => { const r = [...roles]; r[i] = { ...role, permissions: { ...role.permissions, [k]: v } }; setRoles(r); }} />
          )}
        </section>
      ))}
    </div>
  );
}
